type Theme = 'light' | 'dark' | 'system';

/** La escribe la piel (src/tema/tema.ts): oscuro con Noche y Smarty oscuro, claro con los demás. */
const STORAGE_KEY = 'sf_app_theme';
const DARK_CLASS = 'dark';

function getSystemTheme(): 'light' | 'dark' {
  if (typeof window === 'undefined' || !window.matchMedia) return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function readStoredTheme(): Theme {
  if (typeof window === 'undefined') return 'light';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark' || stored === 'system') return stored;
  return 'light';
}

function applyThemeClass(theme: Theme) {
  if (typeof document === 'undefined') return;
  const resolved = theme === 'system' ? getSystemTheme() : theme;
  const root = document.documentElement;
  if (resolved === 'dark') root.classList.add(DARK_CLASS);
  else root.classList.remove(DARK_CLASS);
}

/**
 * Aplica el modo guardado lo antes posible (evita flash).
 * Llamarlo una vez al arrancar la app (main.tsx) — idempotente.
 */
export function initAppTheme() {
  applyThemeClass(readStoredTheme());
}
